import React from 'react';
import {
  Box,
  Skeleton
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  line: {
    height: 40,
    marginBottom: 20
  }
}));

export default function ArticleBodySkeleton ({ marginTop }) {
  const classes = useStyles();
  return (
    <Box sx={{ mt: marginTop || 0 }}>
      <Skeleton variant='rectangle' className={classes.line} />
      <Skeleton variant='rectangle' className={classes.line} />
      <Skeleton variant='rectangle' className={classes.line} />
      <Skeleton variant='rectangle' className={classes.line} />
      <Skeleton variant='rectangle' className={classes.line} />
      <Skeleton variant='rectangle' className={classes.line} />
    </Box>
  );
}
